.text {
  font-size: 15px;
}
